import { render, staticRenderFns } from "./bullhorn-error-block.vue?vue&type=template&id=38dfa1b2"
import script from "./bullhorn-error-block.vue?vue&type=script&lang=js"
export * from "./bullhorn-error-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports